import { EnumSchema } from '@40seas/entities/common';
import { z } from 'zod';
import { ACHAccountType } from './ach.account-type.enum';
import { BankAccountPayload, BaseBankAccountPayloadSchema } from './bank-account.payload.entity';

export const AchBankAccountPayloadSchema = BaseBankAccountPayloadSchema.merge(
    z.object({
        accountNumber: z.string().regex(/^[a-zA-Z0-9\\s]{4,34}$/, { message: 'Account Number should contain 4 to 34 letters or digits' }),
        routingNumber: z.string().regex(/^\d{9}$/, { message: 'Routing Number should contain 9 digits' }),
        accountType: z.string(EnumSchema(ACHAccountType)).optional(),
    }),
);

export class AchBankAccountPayload extends BankAccountPayload {
    accountNumber: string;
    routingNumber: string;
    accountType?: string;
}
